<template>
    <section class="recharge-payment-view">
        <HeaderComponent :title="'Pagamento com Cartão'" />

        <div class="container">
            <div class="totalValue">
                <h1>Valor Total</h1>
                <h1 v-if="isInvoiceMode" v-text="formatValue(invoiceTotalValue)"></h1>
                <h1 v-else v-text="formatValue(totalRechargeValue)"></h1>
            </div>

            <!-- pagar com cartão cadastrado -->
            <div class="cards-list" v-if="Object.values(userCardList).length > 0">
                <h1>
                    Clique em um cartão para selecionar:
                </h1>
                <div class="list-fields">
                    <span v-for="(field, key) in listFields" :key="key" v-text="field"></span>
                </div>
                <div class="card-item" v-for="(card, key) in cardsList" :key="key" @click="selectCard(card)" :class="{selected: selectedCard == card}">
                    <div v-for="(cardDet, cdetkey) in ['NRULTNUM', 'NMTITULAR', 'DTEXPIRACAO', 'NMBANDEIRA']" :key="cdetkey" >
                        <span :class="cardDet" v-if="cardDet == 'DTEXPIRACAO'" v-text="getExpirationAsDate(card[cardDet])"></span>
                        <span :class="cardDet" v-else-if="cardDet == 'NRULTNUM'" v-text="'Final ' + card[cardDet]"></span>
                        <img :class="cardDet" v-else-if="cardDet == 'NMBANDEIRA'" :src="getCardFlag(card[cardDet])"/>
                        <span :class="cardDet" v-else v-text="card[cardDet]"></span>
                    </div>
                </div>

            </div>
            <div v-else>
                <span class="not-found">Não foram encontrados cartões associados a está conta!</span>
            </div>

            <div class="new-card">
                <span @click="newCardPayment">Pagar com outro cartão</span>
            </div>

            <div class="button-cont" v-if="Object.values(userCardList).length > 0">
                <ButtonCenter :button="confirmButton" @click="pay"/>
            </div>
        </div>

        <ModalInfo :modalOpen="confirmationModalOpen" @closeModal="finishRecharge" />
        <ScreenLoader :isLoading="isLoading" />
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import ModalInfo from '@/components/modals/ModalInfo.vue'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import { showAlertNotification } from '@/libs/Util'
import { doCardTokenRecharge, doCardTokenInvoicePayment, updateSonsAfterRecharge } from '@/components/controllers/CardRechargeController.js'

export default {
    name: 'RechargePaymentView',
    components: {
        HeaderComponent,
        ButtonCenter,
        ModalInfo,
        ScreenLoader
    },
    data () {
        return {
            listFields: ['Final', 'Nome', 'Validade', 'Bandeira'],
            confirmButton: {
                display: 'Confirmar',
                fill: true,
                action: this.pay
            },
            confirmationModalOpen: false,
            isLoading: false,
            selectedCard: null,
            cardsList: []
        }
    },
    computed: {
        ...mapGetters([
            'rechargePaymentInfra', 'totalRechargeValue', 'rechargeValues', 'rechargePaymentData', 'rechargeMode',
            'userCardList', 'rechargeMode', 'isInvoiceMode', 'invoiceTotalValue', 'idBoletos'
        ])
    },
    methods: {
        ...mapActions(['showModalInfo', 'storeSons', 'changeCardCVVMenuVisibility']),
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        confirmCVV () {
            if (!this.selectedCard) {
                showAlertNotification({
                    title: '',
                    text: 'Selecione um cartão para continuar'
                })
                return
            }
            this.changeCardCVVMenuVisibility()
        },
        pay () {
            if (!this.selectedCard) {
                showAlertNotification({
                    title: '',
                    text: 'Selecione um cartão para continuar'
                })
                return
            }

            this.isLoading = true

            const cardToken = this.selectedCard.DSTOKEN
            const cardHolder = this.selectedCard.NMTITULAR
            const cardExpiration = moment(this.selectedCard.DTEXPIRACAO).format('MM/YY')
            const cardCVV = null // pagamento com token não requer o cvv
            const flag = this.selectedCard.NMBANDEIRA.toUpperCase()
            const mode = this.rechargeMode
            const CDTIPORECE = this.selectedCard.CDTIPORECE
            const finalNumbers = this.selectedCard.NRULTNUM

            if (this.isInvoiceMode) {
                doCardTokenInvoicePayment(this.invoiceTotalValue, flag, cardExpiration, cardToken, cardCVV, cardHolder, mode, finalNumbers, this.idBoletos)
                    .then(res => {
                        this.isLoading = false
                        if (res.sucesso) {
                            this.confirmationModalOpen = true
                            this.showModalInfo({
                                type: 'default',
                                text: res.data.message,
                                icon: 'fa-solid fa-circle-check'
                            })
                        }
                    })
            } else {
                doCardTokenRecharge(this.totalRechargeValue, flag, cardExpiration, cardToken, cardCVV, cardHolder, this.rechargeValues, mode, CDTIPORECE, finalNumbers)
                    .then(res => {
                        this.isLoading = false
                        if (res.sucesso) {
                            this.storeSons([])
                            this.confirmationModalOpen = true
                            this.showModalInfo({
                                type: 'default',
                                text: res.data.message,
                                icon: 'fa-solid fa-circle-check'
                            })
                        }
                    })
            }
        },
        getCardFlag (flag) {
            if (flag && flag.length > 2) {
                try {
                    return require('@/assets/default/icons/cardflags/' + flag.toLocaleLowerCase() + '.svg')
                } catch (e) {
                    return require('@/assets/default/icons/cardflags/generic-clean.svg')
                }
            }
            return ''
        },
        finishRecharge () {
            // atualiza o saldo dos filhos
            updateSonsAfterRecharge()

            this.confirmationModalOpen = false
            this.$router.push('/home')
        },
        getExpirationAsDate (date) {
            let expirationDate = moment(date, 'MM/YY')
            if (expirationDate.isValid()) {
                return expirationDate.format('MM/YY')
            }
            expirationDate = moment(date)
            if (expirationDate.isValid()) {
                return expirationDate.format('MM/YY')
            }
        },
        selectCard (card) {
            if (this.selectedCard === card) {
                this.selectedCard = null
                return
            }

            this.selectedCard = card
        },
        newCardPayment () {
            this.$router.push('/cardRecharge/newCardPayment')
        }
    },
    mounted () {
        this.cardsList = Object.values(this.userCardList)
    }
}
</script>

<style lang="less" scoped>
.container {
    height: calc(100vh - 60px);
    overflow-y: auto;
    margin-top: -15px;

    &::-webkit-scrollbar {
        display: none;
    }
}

.totalValue {
    display: flex;
    justify-content: space-between;
    margin: 30px 0px;
    h1 {
        font-weight: 600;
    }
}

.cards-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 30px;

    h1 {
        font-size: 18px;
        margin-bottom: 30px;
        align-self: baseline;
    }

    .list-fields {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        width: calc(100% - 30px);
        gap: 15px;
        text-align: center;
        margin-bottom: 10px;

        span {
            font-size: 16px;
            font-weight: 600;
        }
    }

    .card-item {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 15px;
        width: calc(100% - 35px);
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
        background-color: var(--cardBackground);
        font-size: 16px;
        font-weight: 600;
        word-break: break-word;
        text-align: center;

        img {
            width: 60px;
            height: 40px;
            border-radius: 10px;
        }

        span {
            font-size: 16px;
            font-weight: 600;
            margin-left: 10px;
        }

        &.selected {
            border: 2px solid var(--primaryColor);
            color: var(--primaryColor)
        }
    }

    .not-found {
        font-size: 16px;
        font-weight: 600;
    }
}

.new-card {
    display: flex;
    justify-content: center;
    margin: 25px 0px;

    span {
        font-size: 16px;
        font-weight: 600;
        color: var(--buttonBackground);
    }
}

.button-cont {
    margin-top: 35px;

    button {
        width: calc(100% - 30%);
    }
}

</style>
